import React, {useState} from 'react'
import PropTypes from 'prop-types'
import style from './style.module.scss'
import { Switch } from '../Switch';
import { CircleButton } from '../CircleButton';
import Vector from './vector.svg';
import formatCurrency from '../../../utils'

var moment = require('moment');

export const Table = (props) => {
    const [groupByYear, setgroupByYear] = useState(false)

    function handleSwitchOnClick(value){
        setgroupByYear(value)
    }

    // Realiza o group by do array informado formatando o elemento para ano
    function groupBy(array, key){
        return array.reduce((result, currentValue) => {
          (result[moment(currentValue[key]).format('YYYY')] = result[moment(currentValue[key]).format('YYYY')] || []).push(
            currentValue
          );
          return result;
        }, {});
    };
  
    // Realiza o groupBy e retorna com os novos valores
    function groupColumn(column){
        let value = Object.assign({}, column)
        
        let aux = groupBy(value.data, 'x')
        value.data = []
        Object.keys(aux).forEach(year => {
          value.data.push({"x": aux[year][aux[year].length-1].x, "y": aux[year][aux[year].length-1].y})
        });
  
        return value
    }
  
    function criaTabela(investidoParam, acumuladoParam){
        let investido = Object.assign({}, investidoParam)
        let acumulado = Object.assign({}, acumuladoParam)
        
        if(groupByYear){
          investido = groupColumn(investido)
          acumulado = groupColumn(acumulado)
        }
  
        let table = []
        let columns = []
        for (let coluna = 0; coluna < investido.data.length; coluna++) {
          let row = []
          row.push(<div className={style.columnName}>{(groupByYear) ? moment(investido.data[coluna].x).format('YYYY') : moment(investido.data[coluna].x).format('MMM YY')}</div>)
          // Adiciona linha de valor investido
          row.push(<div className={style.tableData}>{formatCurrency(investido.data[coluna].y)}</div>)
          // Adiciona linha de Juros
          row.push(<div className={style.tableData}>{formatCurrency(acumulado.data[coluna].y - investido.data[coluna].y)}</div>)
          // Adiciona linha de Redimento
          row.push(<div className={style.tableData}>{formatCurrency(((acumulado.data[coluna].y - investido.data[coluna].y)/investido.data[coluna].y)*100)}%</div>)
          // Adiciona linha de valor total
          row.push(<div className={style.tableDataBold}>{formatCurrency(acumulado.data[coluna].y)}</div>)
          columns.push(<div style={{flex: 1}}>{row}</div>)
        }
        table.push(
          <div className={style.table}>
            <div className={style.rowLegend}>
              <div className={style.columnNameNoBorder}>&nbsp;</div>
              <div className={style.tableData}>Investido (R$)</div>
              <div className={style.tableData}>Juros (R$)</div>
              <div className={style.tableData}>Rendimento</div>
              <div className={style.tableDataBold}>Valor Final (R$)</div>
              <div>&nbsp;</div>
            </div>
            <div className={style.tableColumns}>{columns}</div>
          </div>
        )
        return table
    }

    function criaTabelaMobile(investidoParam, acumuladoParam){
        let investido = Object.assign({}, investidoParam)
        let acumulado = Object.assign({}, acumuladoParam)
        
        if(groupByYear){
          investido = groupColumn(investido)
          acumulado = groupColumn(acumulado)
        }
  
        let table = []
        let columns = []
        for (let coluna = 0; coluna < investido.data.length; coluna++) {
          let row = []
          row.push(
              <div className={style.columnMobile}>
                <div className={style.columnNameNoBorder}>{(groupByYear) ? moment(investido.data[coluna].x).format('YYYY') : moment(investido.data[coluna].x).format('MMM YY')}</div>
                <div className={style.tableData}>{formatCurrency(investido.data[coluna].y)}</div>
                <div className={style.tableData}>{formatCurrency(acumulado.data[coluna].y - investido.data[coluna].y)}</div>
                <div className={style.tableData}>{formatCurrency(((acumulado.data[coluna].y - investido.data[coluna].y)/investido.data[coluna].y)*100)}%</div>
                <div className={style.tableDataBold}>{formatCurrency(acumulado.data[coluna].y)}</div>
            </div>
          )
          columns.push(<div style={{flex: 1}}>{row}</div>)
        }
        table.push(
          <div className={style.tableMobile}>
            <div className={style.columnMobile}>
              <div className={style.columnNameNoBorder}>&nbsp;</div>
              <div className={style.tableData}>Investido (R$)</div>
              <div className={style.tableData}>Juros (R$)</div>
              <div className={style.tableData}>Rend.</div>
              <div className={style.tableDataBold}>Valor Final (R$)</div>
              <div>&nbsp;</div>
            </div>
            <div className={style.rowLegend}>{columns}</div>
          </div>
        )
        return table
    }

    return (
        <div className={style.main}>
            {(window.screen.width <= 768)?criaTabelaMobile(props.Investimento, props.Acumulado):criaTabela(props.Investimento, props.Acumulado)}
            <div className={style.tableFooter}>
                <Switch firstOption={'MESES'} secondOption={'ANOS'} onCLick={handleSwitchOnClick}/>
                <CircleButton icon={<Vector fill='#4B6584'/>} onCLick={props.changeViewType} label="VER GRÁFICO"/>
            </div>
        </div>
    )
}
